import { registerComponent as k } from "@aileron/icon";
import { unsafeCSS as x, LitElement as y, nothing as w } from "lit";
import { unsafeStatic as $, html as p } from "lit/static-html.js";
import { property as u, state as v, queryAll as I } from "lit/decorators.js";
const S = (o) => {
  class e extends o {
    constructor(...r) {
      super(...r), this.fontLink = "https://www.aa.com/fonts/css/family/american-sans-variable.css";
      const i = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(i.getElementsByTagName("link")).findIndex(
        (d) => d.href === this.fontLink
      ) === -1) {
        const d = document.createElement("link");
        d.href = this.fontLink, d.rel = "stylesheet", document.head.appendChild(d);
      }
    }
  }
  return e;
}, A = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}strong{font-weight:700;font-variation-settings:"wght" 700}.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.static{position:static}.block{display:block}.inline{display:inline}.table{display:table}.hidden{display:none}.border{border-width:1px}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}[hidden]{display:none!important}', E = x(A), m = "aileron-color-scheme", g = "aileron-color-scheme-change", z = (o) => {
  const t = class t extends o {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (i) => {
        i.detail ? this.setAttribute(m, i.detail) : this.removeAttribute(m);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        g,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const i = document.documentElement.getAttribute(
        m
      );
      i && this.setAttribute(m, i);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        g,
        this.handleSchemeSwitch
      );
    }
  };
  t.styles = [
    E,
    o.styles ?? []
  ];
  let e = t;
  return e;
}, _ = z(S(y));
function h(o, e, t) {
  const r = new CustomEvent(e, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...t
  });
  return o.dispatchEvent(r), r;
}
const L = ".aileron-listbox{display:flex;flex-direction:column}.aileron-listbox__list{max-height:24rem;overflow-x:hidden;overflow-y:auto;display:relative;border:.0625rem solid transparent}.aileron-listbox__list:focus,.aileron-listbox__list:focus-visible{border:.0625rem solid transparent;outline:none}.aileron-listbox__list-item{font-size:1rem;line-height:1.5rem;display:flex;width:100%;text-align:left;padding:12px 16px;cursor:pointer;border-bottom:.0625rem solid transparent}.aileron-listbox__list-item:hover{background-color:#e0f2ff}.aileron-listbox__list-item:active{background-color:#d6edff}.aileron-listbox__list-item:last-of-type{border-bottom:0}.aileron-listbox__search{border-radius:.25rem;border:.0625rem solid #869199;margin:1rem;display:flex;gap:.5rem;padding:.75rem}.aileron-listbox__search:focus-within{border-color:#006dc0;outline:.125rem solid #006DC0;outline-offset:.125rem}.aileron-listbox__search:first-child{margin-right:.75rem;min-width:1.5rem}.aileron-listbox__search-input{line-height:1.5rem;flex-grow:1;overflow:hidden}.aileron-listbox__search-input:focus,.aileron-listbox__search-input:focus-visible{border:none;outline:none}.aileron-listbox__label{flex-grow:1;pointer-events:none;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.aileron-listbox__unchecked,.aileron-listbox__checked,.aileron-listbox__icon{margin-right:12px;display:none;pointer-events:none;min-width:24px}.aileron-listbox__icon{margin-left:8px}.aileron-listbox__checked{color:#006dc0}.aileron-listbox__screen-reader{position:absolute;height:1px;width:1px;overflow:hidden;clip:rect(1px,1px,1px,1px)}[aria-selected=true] .aileron-listbox__icon,[aria-selected=false] .aileron-listbox__unchecked,[aria-selected=true] .aileron-listbox__checked{display:block}[aria-selected=true].aileron-listbox__list-item{background-color:#eaf6ff}[aria-selected=true].aileron-listbox__list-item:hover{background-color:#e0f2ff}[aria-selected=true].aileron-listbox__list-item:active{background-color:#d6edff}[data-focused]{outline:.125rem solid #006DC0;outline-offset:-.125rem}";
var T = Object.defineProperty, c = (o, e, t, r) => {
  for (var i = void 0, a = o.length - 1, b; a >= 0; a--)
    (b = o[a]) && (i = b(e, t, i) || i);
  return i && T(e, t, i), i;
};
const l = "aileron-listbox", s = {
  root: l,
  list: `${l}__list`,
  listItem: `${l}__list-item`,
  search: `${l}__search`,
  searchInput: `${l}__search-input`,
  screenReader: `${l}__screen-reader`,
  trigger: `${l}__trigger`,
  label: `${l}__label`,
  icon: `${l}__icon`,
  unchecked: `${l}__unchecked`,
  checked: `${l}__checked`
}, f = class f extends _ {
  constructor(e) {
    super(), this.options = [], this.includeSearch = !1, this.required = !1, this.ariaLabel = null, this.value = "", this.multiSelect = !1, this._error = !1, this._filter = "", this.customElementString = e;
  }
  connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-listbox"), k(
      this.customElementString ? this.customElementString + "-listbox" : "adc-listbox"
    );
  }
  /**
   * Creates custom tag name
   */
  createTagName(e) {
    return $(
      this.customElementString ? this.customElementString + e : "adc" + e
    );
  }
  /**
   * Finds index of list item that matches first component value
   * @returns _listItems array index
   */
  _findSelectedIndex() {
    let e = [], t = 0;
    return this.value && (e = this.value.split(", "), t = Array.from(this._listItems).findIndex((r) => r.querySelector(`.${s.label}`).dataset.value === e[e.length - 1])), t;
  }
  /**
   * Finds index of list item that is currently focused
   * @returns _listItems array index
   */
  _findFocusedIndex() {
    const e = this.renderRoot.querySelector("[data-focused]");
    return Array.from(this._listItems).findIndex(
      (t) => t === e
    );
  }
  /**
   * Sets focus on a given element and updates aria-activedescendant on list owner
   */
  _focusItem(e) {
    this.renderRoot.querySelector(`.${s.list}`).setAttribute("aria-activedescendant", e.id), Array.from(this._listItems).forEach((t) => {
      t.id === e.id ? (t.setAttribute("data-focused", ""), t.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      })) : t.removeAttribute("data-focused");
    });
  }
  /**
   * Sets focus on current focused item's previous neighbor.
   * If includeSearch is false, focus will wrap to bottom at top of list.
   * If includeSearch is false, focus will focus search input at top of list.
   */
  _focusPreviousItem() {
    const e = this._findFocusedIndex();
    e - 1 < 0 ? this.includeSearch ? (this.renderRoot.querySelector(
      `.${s.searchInput}`
    ).focus(), this.renderRoot.querySelector(
      `.${s.list}`
    ).blur()) : this._focusItem(this._listItems[this._listItems.length - 1]) : this._focusItem(this._listItems[e - 1]);
  }
  /**
   * Sets focus on current focused item's next neighbor.
   * Focus will wrap to top at bottom of list.
   */
  _focusNextItem() {
    const e = this._findFocusedIndex();
    e + 1 > this._listItems.length - 1 ? this._focusItem(this._listItems[0]) : this._focusItem(this._listItems[e + 1]);
  }
  /**
   * Sets focus on first list item.
   */
  _focusFirstItem() {
    this._focusItem(this._listItems[0]);
  }
  /**
   * Sets focus on last list item.
   */
  _focusLastItem() {
    this._focusItem(this._listItems[this._listItems.length - 1]);
  }
  /**
   * Sets focus on target and selects list item.
   * @param event - Click event
   */
  _handleClick(e) {
    this._focusItem(e.target), this._selectFocusedItem(), h(this, "adc-listitem-click");
  }
  /**
   * Updates component value to list item's text if list item is not already selected.
   * If list item is already selected, updates value to null. (Disabled if required is true)
   */
  _selectFocusedItem() {
    const r = this.renderRoot.querySelector("[data-focused]").querySelector(
      `.${s.label}`
    ).dataset.value;
    let i = [];
    if (this.value && (i = this.value.split(", ")), this.multiSelect) {
      if (!i.includes(r))
        i.push(r);
      else if (this.required !== !0) {
        const a = i.indexOf(r);
        i.splice(a, 1);
      } else if (this.required === !0 && i.length > 1) {
        const a = i.indexOf(r);
        i.splice(a, 1);
      }
    } else if (!i.includes(r))
      i = [r];
    else if (this.required !== !0) {
      const a = i.indexOf(r);
      i.splice(a, 1);
    }
    this.required && this._error && (this._error = !1), i.length > 1 ? this.value = i.join(", ") : this.value = i[0];
  }
  /**
   * Handles keys for listbox.
   * @param event - Keydown event
   */
  _handleKeyDown(e) {
    switch (e.code) {
      case "ArrowUp":
        e.preventDefault(), this._focusPreviousItem();
        break;
      case "ArrowDown":
        e.preventDefault(), this._focusNextItem();
        break;
      case "Home":
        e.preventDefault(), this._focusFirstItem();
        break;
      case "End":
        e.preventDefault(), this._focusLastItem();
        break;
      case "Enter":
      case "Space":
        e.preventDefault(), this._selectFocusedItem();
        break;
    }
    h(this, "adc-listbox-keydown");
  }
  /**
   * Handles keys for search input.
   * @param event - Keydown event
   */
  _handleTextInputKeydown(e) {
    const t = this.renderRoot.querySelector(
      `.${s.list}`
    );
    switch (e.stopPropagation(), e.code) {
      case "ArrowDown":
        e.preventDefault(), t.focus();
        break;
      case "ArrowUp":
        e.preventDefault();
        break;
    }
    h(this, "adc-search-keydown");
  }
  /**
   * Handles listbox focus and sets focus on list owner's active descendant.
   */
  _handleFocus() {
    const e = this.renderRoot.querySelector(`.${s.list}`).getAttribute("aria-activedescendant");
    Array.from(this._listItems).forEach((t) => {
      t.id === e ? t.setAttribute("data-focused", "") : t.removeAttribute("data-focused");
    }), h(this, "adc-listbox-focus");
  }
  /**
   * Handles listbox blur and removes focus from list items.
   * Checks value for null if required is true and sets _error to true if no list item selected.
   */
  _handleBlur() {
    this._listItems.forEach((e) => {
      e.removeAttribute("data-focused");
    }), this.required && (this.value === null || this.value === "") ? this._error = !0 : this._error = !1, h(this, "adc-listbox-blur");
  }
  /**
   * Filters option list based off of filter value.
   * @param filter - String for matching list items
   */
  _filterOptions(e) {
    if ((e == null ? void 0 : e.length) > 0) {
      const t = new RegExp(e, "i"), r = [];
      return this.options.filter((i) => {
        const a = this._getLabelText(i);
        t.test(a) && r.push(i);
      }), r.map((i, a) => {
        const b = this._getValue(i), d = this._getLabelText(i);
        return this._renderListItem(d, a, b);
      });
    }
    return this.options.map((t, r) => {
      const i = this._getValue(t), a = this._getLabelText(t);
      return this._renderListItem(a, r, i);
    });
  }
  /**
   * Sets filter value to search input value.
   * @param event - Input event
   */
  _handleTextInput(e) {
    this._filter = e.target.value, h(this, "adc-search-input");
  }
  /**
   * Gets the label text of the option to be displayed
   * @param option - Array with the options to be displayed
   */
  _getLabelText(e) {
    return typeof e == "object" ? e.labelText ? e.labelText : e.value : e;
  }
  /**
   * Gets the value of the option to be displayed
   * @param option - Array with the options to be displayed
   */
  _getValue(e) {
    return typeof e == "object" ? e.value ? e.value : e.labelText : e;
  }
  _includesLabel(e) {
    var r;
    const t = (r = this.value) == null ? void 0 : r.split(", ");
    return t ? t == null ? void 0 : t.includes(e) : !1;
  }
  /**
   * Creates list item element for listbox.
   * @param text - Text content for list item
   * @param index - index of list item for id
   * @returns li element
   */
  _renderListItem(e, t, r) {
    return this.multiSelect ? p`
        <li
          role="option"
          class=${s.listItem}
          aria-selected=${this._includesLabel(r)}
          id=${`adc-lb-${t}`}
          @click="${this._handleClick}"
        >
          <${this.createTagName("-listbox-icon")}
            class=${s.unchecked}
            icon="action:select-empty"
            size="24"
            aria-hidden="true"
          ></${this.createTagName("-listbox-icon")}>
          <${this.createTagName("-listbox-icon")}
            class=${s.checked}
            icon="action:select-checked"
            size="24"
            aria-hidden="true"
          ></${this.createTagName("-listbox-icon")}>
          <span data-value=${r} class=${s.label}
            >${e}</span
          >
        </li>
      ` : p`
      <li
        role="option"
        class=${s.listItem}
        aria-selected=${this._includesLabel(r)}
        id=${`adc-lb-${t}`}
        @click="${this._handleClick}"
      >
        <span data-value=${r} class=${s.label}>${e}</span>
        <${this.createTagName("-listbox-icon")}
          class=${s.icon}
          icon="signal:checkmark"
          size="24"
          aria-hidden="true"
          ></${this.createTagName("-listbox-icon")}>
      </li>
    `;
  }
  _renderOptions(e) {
    return this.includeSearch ? p`
        <div class=${s.search}>
        <${this.createTagName(
      "-listbox-icon"
    )} icon="operation:search" size="24"></${this.createTagName(
      "-listbox-icon"
    )}>
          <label class=${s.screenReader} for="adc-lb-search">
            Filter listbox options
          </label>
          <input
            type="text"
            id="adc-lb-search"
            class=${s.searchInput}
            @input=${this._handleTextInput}
            @keydown="${this._handleTextInputKeydown}"
          />
        </div>
        <ul
          aria-label="${this.ariaLabel || w}"
          aria-activedescendant="adc-lb-${e}"
          aria-invalid="${this._error}"
          id="adc-lb-ul"
          class=${s.list}
          role="listbox"
          tabindex="-1"
          @blur="${this._handleBlur}"
          @focus="${this._handleFocus}"
          @keydown="${this._handleKeyDown}"
          aria-busy="false"
        >
          ${this._filterOptions(this._filter)}
        </ul>
      ` : p`
      <ul
        aria-label="${this.ariaLabel || w}"
        aria-invalid="${this._error}"
        class=${s.list}
        id=${"adc-lb-ul"}
        role="listbox"
        tabindex="0"
        @focus="${this._handleFocus}"
        @blur="${this._handleBlur}"
        @keydown="${this._handleKeyDown}"
        aria-activedescendant="adc-lb-${e}"
        aria-busy="false"
        aria-multiselectable="${this.multiSelect}"
      >
        ${this._filterOptions(null)}
      </ul>
    `;
  }
  updated(e) {
    super.updated(e), e.has("value") && this.renderRoot.querySelector(`.${s.list}`).setAttribute(
      "aria-activedescendant",
      `adc-lb-${this._findSelectedIndex() > -1 ? this._findSelectedIndex() : 0}`
    );
  }
  render() {
    const e = this._findSelectedIndex() > -1 ? this._findSelectedIndex() : 0;
    return p` <div class=${s.root}>
      ${this._renderOptions(e)}
    </div>`;
  }
};
f.styles = [_.styles || [], x(L)], f.shadowRootOptions = {
  ...y.shadowRootOptions,
  delegatesFocus: !0
};
let n = f;
c([
  u({ type: Array })
], n.prototype, "options");
c([
  u({ attribute: "include-search", type: Boolean, reflect: !0 })
], n.prototype, "includeSearch");
c([
  u({ type: Boolean, reflect: !0 })
], n.prototype, "required");
c([
  u({ attribute: "aria-label" })
], n.prototype, "ariaLabel");
c([
  u({ type: String, reflect: !0 })
], n.prototype, "value");
c([
  u({ attribute: "multi-select", type: Boolean, reflect: !0 })
], n.prototype, "multiSelect");
c([
  v()
], n.prototype, "_error");
c([
  v()
], n.prototype, "_filter");
c([
  I(`.${s.listItem}`)
], n.prototype, "_listItems");
try {
  customElements.define("adc-listbox", n), console.warn(
    "@aileron/listbox is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/listbox"
  );
} catch {
}
function C(o) {
  try {
    customElements.define(
      `${o}-listbox`,
      class extends n {
        constructor() {
          super(o);
        }
      }
    );
  } catch {
  }
}
function N(o) {
  try {
    C(o);
  } catch {
  }
}
export {
  n as Listbox,
  N as registerComponent
};
